export default __webpack_public_path__ + "static/media/012-jewelry.bb5c0b98.svg";